<template>
    <v-tooltip right>
        <template v-slot:activator="{ on }">
            <v-chip small :color="color" class="white--text" v-on="on">{{ short }}</v-chip>
        </template>
        <span>{{ label }}</span>
    </v-tooltip>
</template>

<script>
    const colors = [
        'indigo',
        'pink',
        'cyan',
        'lime darken-1',
        'amber'
    ];

    export default {
        props: {
            label: String,
            short: String
        },

        computed: {
            color() {
                return colors[this.short.charCodeAt(0) % colors.length];
            }
        }
    }
</script>
